import { IconDispatcher } from "shared/Icons";
import styled from "styled-components/macro";
import { v4 as uuid } from "uuid";

export function Counter({ value, icon, iconColor, textColor = "#262626" }) {
	return (
		<ConterContainer key={uuid()}>
			<IconContainer color={iconColor}>{IconDispatcher(icon, "", { style: "light" })}</IconContainer>
			<Value color={textColor}>{value}</Value>
		</ConterContainer>
	);
}

const ConterContainer = styled.div`
	display: flex;
	justify-content: space-between;
`;

const Value = styled.div`
	color: ${({ color }) => color};
	text-align: center;
	font-family: "Oswald";
	font-size: 40px;
	font-style: normal;
	font-weight: 600;
	line-height: 48px;
`;

const IconContainer = styled.div`
	svg {
		height: 48px;
		width: 48px;
	}
	path {
		fill: ${({ color }) => color};
	}
`;
